import React, { useState } from 'react'
import { Icon } from '@iconify/react';
import ClassroomAssessmentQuestions from './ClassroomAssessmentQuestions'
import ClassroomAssessmentResult from './ClassroomAssessmentResult'
import { useParams } from 'react-router-dom';
import { decodeData } from '../../../utils/encodeAndEncode';
import { usePermissions } from '../../../context/PermissionsContext';
import { toast } from 'react-toastify';

function ClassroomAssessmentDetails() {
  const { permissions } = usePermissions();
  const { classroomId, assessmentId } = useParams();
  const decodedClassroomId = decodeData(classroomId);
  const decodedAssessmentId = decodeData(assessmentId);
  // console.log('decodedClassroomId',decodedClassroomId);
  // console.log('decodedAssessmentId',decodedAssessmentId);
  const [activeTab, setActiveTab] = useState('questions');

  const handleTabChange = (tab) => {
    if (tab === 'questions' && !permissions.classroom_assessment_question_view) {
      toast.warning("You don't have permission to view questions");
      return;
    }
    if (tab === 'results' && !permissions.classroom_assessment_result_view) {
      toast.warning("You don't have permission to view results");
      return;
    }
    setActiveTab(tab);
  };

  return (
    <div className="flex">
      <div className="w-full">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100">
          <div className="p-0">
          
            {/* Tabs */}
            <div className="border-b border-gray-200">
              <ul className="flex border-b border-gray-200">
                <li>
                  <button
                    className={`px-4 py-2 text-gray-600 hover:text-primary flex items-center ${activeTab === 'questions' ? 'text-primary border-b-2 border-primary' : ''} ${!permissions.classroom_assessment_question_view ? 'disabled opacity-75' : ''}`}
                    onClick={() => handleTabChange('questions')}
                    disabled={!permissions.classroom_assessment_question_view}
                    title={!permissions.classroom_assessment_question_view ? "You don't have permission to view questions" : "View assessment questions"}
                    style={{ cursor: !permissions.classroom_assessment_question_view ? 'not-allowed' : 'pointer' }}
                  >
                    <Icon icon="fluent:quiz-new-24-regular" className="mr-2" width="20" height="20" />
                    Questions
                  </button>
                </li>
                <li>
                  <button
                    className={`px-4 py-2 text-gray-600 hover:text-primary flex items-center ${activeTab === 'results' ? 'text-primary border-b-2 border-primary' : ''} ${!permissions.classroom_assessment_result_view ? 'disabled opacity-75' : ''}`}
                    onClick={() => handleTabChange('results')}
                    disabled={!permissions.classroom_assessment_result_view}
                    title={!permissions.classroom_assessment_result_view ? "You don't have permission to view results" : "View assessment results"}
                    style={{ cursor: !permissions.classroom_assessment_result_view ? 'not-allowed' : 'pointer' }}
                  >
                    <Icon icon="fluent:clipboard-task-24-regular" className="mr-2" width="20" height="20" />
                    Results
                  </button>
                </li>
              </ul>
            </div>

            {/* Tab Content */}
            <div className="tab-content p-4">
              {activeTab === 'questions' && permissions.classroom_assessment_question_view && (
                <div className="questions">
                  <ClassroomAssessmentQuestions decodedClassroomId={decodedClassroomId} decodedAssessmentId={decodedAssessmentId} />
                </div>
              )}

              {activeTab === 'results' && permissions.classroom_assessment_result_view && (
                <div className="results">
                  <ClassroomAssessmentResult decodedClassroomId={decodedClassroomId} decodedAssessmentId={decodedAssessmentId} />
                </div>
              )}

              {((activeTab === 'questions' && !permissions.classroom_assessment_question_view) ||
                (activeTab === 'results' && !permissions.classroom_assessment_result_view)) && (
                <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded m-3">
                  You don't have permission to view this content.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClassroomAssessmentDetails
